<template>
    <div
        class="pointer-events-none absolute inset-0 z-0 flex items-center justify-center overflow-hidden"
    >
        <div class="robot-backdrop">
            <AnimatedRobot />
        </div>
    </div>
</template>

<script lang="ts" setup>
// Decorative, softened DMARCeye robot behind frosted panels — the shared AI
// identity backdrop used across chat, saved content and the dashboard.
</script>

<style scoped>
.robot-backdrop {
    opacity: 0.3;
    filter: grayscale(25%) blur(9px);
    animation: backdropDrift 16s ease-in-out infinite;
    will-change: transform;
}

.robot-backdrop :deep(.robot-anim),
.robot-backdrop :deep(.robot-anim svg) {
    width: 540px !important;
    height: 540px !important;
}

.robot-backdrop :deep(#robotMessage) {
    display: none !important;
}

@keyframes backdropDrift {
    0%,
    100% {
        transform: translate(-40px, 0) rotate(-2deg);
    }
    50% {
        transform: translate(40px, -12px) rotate(2deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .robot-backdrop {
        animation: none !important;
    }
}
</style>
